module.exports = __webpack_public_path__ + "img/box-arrow-in-down-left.fe496246.svg";